module.exports = __webpack_public_path__ + "media/images/fbcalls/telegram-3d61fe069013958f991340424db0a707.png";